// Small floating WhatsApp logo button.
// Uses the official WhatsApp glyph (simplified SVG) for instant recognition.
import { trackLead } from "@/lib/analytics";

const WHATSAPP_NUMBER = "919501030117";
const DEFAULT_TEXT = encodeURIComponent(
  "Hello Vacations Pro — I'd like help planning a trip."
);

export default function WhatsAppFloat() {
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${DEFAULT_TEXT}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float-btn"
      onClick={() => trackLead({ source: "whatsapp_float" })}
      className="fixed bottom-24 right-5 z-40 w-14 h-14 flex items-center justify-center bg-[#25D366] hover:bg-[#1ebe5d] text-white rounded-full shadow-[0_12px_30px_rgba(37,211,102,0.45)] transition-all hover:-translate-y-0.5"
    >
      <svg viewBox="0 0 32 32" className="w-7 h-7" fill="currentColor" aria-hidden="true">
        <path d="M19.11 17.21c-.32-.16-1.87-.92-2.16-1.03-.29-.11-.5-.16-.71.16-.21.32-.82 1.03-1 1.24-.18.21-.37.24-.68.08-.32-.16-1.34-.49-2.55-1.57-.94-.84-1.58-1.87-1.77-2.19-.18-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.18.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.71-1.71-.97-2.34-.26-.62-.52-.54-.71-.55-.18-.01-.4-.01-.61-.01-.21 0-.56.08-.85.4-.29.32-1.11 1.09-1.11 2.66 0 1.57 1.14 3.09 1.3 3.3.16.21 2.25 3.44 5.45 4.82.76.33 1.36.53 1.82.68.76.24 1.46.21 2.01.13.61-.09 1.87-.76 2.14-1.49.26-.73.26-1.36.18-1.49-.08-.13-.29-.21-.61-.37zM16 4C9.38 4 4 9.38 4 16c0 2.17.57 4.2 1.56 5.97L4.05 28l6.2-1.62A11.93 11.93 0 0 0 16 28c6.62 0 12-5.38 12-12S22.62 4 16 4zm0 22.15c-1.83 0-3.58-.48-5.12-1.39l-.37-.22-3.67.96.98-3.58-.24-.38A9.84 9.84 0 0 1 6.15 16C6.15 10.58 10.58 6.15 16 6.15 21.42 6.15 25.85 10.58 25.85 16c0 5.42-4.43 10.15-9.85 10.15z"/>
      </svg>
    </a>
  );
}
